const zoomDashboardList = [
  {
    label: 'My Dashboard',
    key: 'My Dashboard',
    expanded: false,
    className: 'selectedMenuObj',
    endPoint: '/booking'
  },
  {
    label: 'Pickups',
    key: 'BOOKINGS',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    subMenu: [
      {
        label: 'PRQ',
        key: 'PRQ',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/3b23e806-f8da-4309-84bf-1e446e46d694'
      },
      {
        label: 'Load',
        key: 'Load',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/f412c0df-022e-4b5c-87eb-ed7cf0fdd6b2'
      }
    ]
  },
  {
    label: 'QC',
    key: 'QC',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    url:
      'https://app.periscopedata.com/shared/1ec6130b-7a05-4e07-8583-8ab1f4081de2'
  },
  {
    label: 'In Stock',
    key: 'In-stock',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    url:
      'https://app.periscopedata.com/shared/1ec6130b-7a05-4e07-8583-8ab1f4081de2'
  },
  {
    label: 'Dispatches',
    key: 'Dispatch',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    url:
      'https://app.periscopedata.com/shared/1ec6130b-7a05-4e07-8583-8ab1f4081de2'
  },
  {
    label: 'CPB',
    key: 'CPB',
    expanded: false,
    roles: ['ROLE_ZOOM_HQTR'],
    endPoint: '/booking',
    className: 'menuObj',
    url:
      'https://app.periscopedata.com/shared/4ca3953b-49a5-4ee8-95a9-42cb418af68c'
  },
  {
    label: 'Delivery',
    key: 'DELIVERY',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    subMenu: [
      {
        label: 'Cumulative stock',
        key: 'Cumulative Stock',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/917a8b7a-a805-4ef5-a89e-375632193b12'
      },
      {
        label: 'POD',
        key: 'POD',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj'
      },
      {
        label: 'DRS',
        key: 'DRS',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/60b1c1b0-e8ee-400b-8dd6-6850dfda86a6'
      },
      {
        label: 'COD/DOD',
        key: 'COD/DOD',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj'
      },
      {
        label: 'FN',
        key: 'FN',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj'
      },
      {
        label: 'Appointment Delivery',
        key: 'Appointment',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj'
      }
    ]
  },
  {
    label: 'Customer Experience',
    key: '',
    expanded: false,
    endPoint: '/booking',
    roles: ['ROLE_ZOOM_HQTR'],
    className: 'menuObj',
    subMenu: [
      {
        label: 'Revenue Achievement',
        key: 'CE Revenue Scorecard',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/2142a607-4b7e-46cb-b976-9e124367b305'
      }
    ]
  },
  {
    label: 'Network',
    key: 'NETWORK',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    subMenu: [
      {
        label: 'LH/Regional LH',
        key: 'LH',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/2142a607-4b7e-46cb-b976-9e124367b305'
      },
      {
        label: 'Feeder',
        key: 'Feeder',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/926375b8-2533-4d93-ad95-974cf334b06d'
      }
    ]
  },
  {
    label: 'DEPS',
    key: 'DEPS',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    url:
      'https://app.periscopedata.com/shared/c7abefd6-650a-40cb-a6fb-0bf6858e439e'
  },
  {
    label: 'Ageing',
    key: 'Ageing',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    url:
      'https://app.periscopedata.com/shared/d11966bb-afa5-46e0-96f4-d8ad876a2ec6'
  },
  {
    label: 'Documents',
    key: 'Document Issues',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj'
  },
  {
    label: 'BP Performance',
    key: 'BP Performance',
    expanded: false,
    endPoint: '/booking',
    roles: ['ROLE_VIEW_PERFORMANCE_DASHBOARD_MENU'],
    className: 'menuObj',
    subMenu: [
      {
        label: 'Performance',
        key: 'BP Performance',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/255e8dc0-f546-4ff3-96ff-2a92565d45f2',
        roles: ['ROLE_VIEW_PERFORMANCE_DASHBOARD_MENU']
      }
    ]
  },
  {
    label: 'BP CN Dashboard',
    key: 'BP CN Performance',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    roles: ['ROLE_VIEW_PERISCOPE_DASHBOARD', 'ROLE_VIEW_COLLECTIONS_HANDOVER'],
    subMenu: [
      {
        label: 'CN Dashboard',
        key: 'BP CN Dashboard',
        expanded: false
      }
    ]
  },
  {
    label: 'Retail Collections (New)',
    key: 'Retail Collections',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    roles: ['ROLE_VIEW_PERFORMANCE_DASHBOARD_MENU', 'ROLE_ZOOM_HQTR']
  },
  {
    label: 'Retail Outstanding',
    key: 'Retail Outstanding',
    expanded: false,
    endPoint: '/booking',
    className: 'menuObj',
    roles: ['ROLE_VIEW_PERFORMANCE_DASHBOARD_MENU']
  },
  {
    label: 'Others',
    key: 'OTHERS',
    expanded: false,
    endPoint: '/booking',
    roles: ['ROLE_VIEW_PERFORMANCE_DASHBOARD_MENU'],
    className: 'menuObj',
    subMenu: [
      {
        label: 'Customer complaints',
        key: 'Customer Complaints',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/2142a607-4b7e-46cb-b976-9e124367b305'
      },
      {
        label: 'Fake Updates',
        key: 'Fake Updates',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/926375b8-2533-4d93-ad95-974cf334b06d'
      },
      {
        label: 'AD success rate',
        key: 'Appointment Delivery Success Rate',
        expanded: false,
        endPoint: '/booking',
        className: 'subMenuObj',
        url:
          'https://app.periscopedata.com/shared/926375b8-2533-4d93-ad95-974cf334b06d'
      }
    ]
  }
];

const testMenu = [
  {
    label: 'm1',
    key: 'm1key',
    expanded: false,
    className: 'm1class',
    endPoint: '/m1'
  },
  {
    label: 'm2',
    key: 'm2key',
    expanded: false,
    className: 'm2class',
    endPoint: '/m2',
    roles: ['r1']
  },
  {
    label: 'm3',
    key: 'm3key',
    expanded: false,
    className: 'm3class',
    endPoint: '/m3',
    roles: ['r2'],
    subMenu: [
      {
        label: 'm3s1',
        key: 'm3s1key',
        expanded: false,
        endPoint: '/m3s1',
        className: 'm3s1class'
      },
      {
        label: 'm3s2',
        key: 'm3s2key',
        expanded: false,
        endPoint: '/m3s2',
        className: 'm3s2class'
      }
    ]
  }
];

const sideMenuConfig = {
  ZOOM_DASHBOARD: zoomDashboardList,
  SIDE_MENU_TEST: testMenu
};

export default sideMenuConfig;
